<template>
    <div class="monitor_wrap" id="monitorDetails">
        <div class="mainHead">
            <div class="route">
                <span class="crumbs"></span><span class="link" @click="returnBtn">监控中心</span><span class="arrow">></span><span>监控详情</span>
            </div>
            <div> 
                <el-button type="primary" @click="returnBtn">返回</el-button>
            </div>
        </div>
        <div class="fixedScorll" :style="{height: heightCard + 'px'}">
            <div class="mains clearfix">
                <div class="main_top">
                    <div class="basic_info">
                        <h3>基本信息</h3>
                        <div class="info_con clearfix">
                            <ul>
                                <li class="clearfix">
                                    <span>监测点名称:</span>
                                    <span style="padding-left: 10px">{{listData.monitoringName}}</span>
                                </li>
                                <li class="clearfix">
                                    <span>监测点编号:</span>
                                    <span style="padding-left: 10px">{{listData.monitoringCode}}</span>
                                </li>
                                <li class="clearfix">
                                    <span>监测点地址:</span>
                                    <div class="addressDiv" :style="{width: addressW + 'px'}" style="padding-left: 10px">
                                        <div class="addressL">
                                            <el-tooltip effect="dark" :content="listData.detailAddress" :disabled="addressW > overflowText" placement="bottom-start">
                                                <i @mouseover="changeText($event)">{{listData.detailAddress}}</i>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </li>
                                <li class="clearfix">
                                    <span>设备状态:</span>
                                    <span v-if="listData.deviceStatus=='启用'" class="green" style="padding-left: 10px">{{listData.deviceStatus}}</span>
                                    <span v-else style="padding-left: 10px;color: #f55353;">{{listData.deviceStatus}}</span>
                                </li>
                            </ul>
                            <ul style="width: 47%">
                                <li class="clearfix">
                                    <span>监测类型:</span>
                                    <span style="padding-left: 10px">{{listData.types}}</span>
                                </li>
                                <li class="clearfix">
                                    <span style="margin-right: 10px">管理人员:</span>
                                  <el-tooltip class="item" effect="dark" :content="listData.basicUserNames" placement="bottom-start" :disabled="tipClientWidth >= tipScrollWidth">
                                     <span class="container_people" @mouseover="isShowTooltip($event)" v-html="listData.usernames"></span>
                                  </el-tooltip>

                                </li>
                                <li class="clearfix">
                                    <span>所在楼层:</span>
                                    <span style="padding-left: 10px">{{listData.floorIndex}}</span>
                                </li>
                                <li class="clearfix">
                                    <span>启用状态:</span>
                                    <span class="green" style="padding-left: 10px">{{listData.enabled}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="current_state" :style="{width: currentWidth + 'px'}">
                        <h3>当前状态<span>{{listData.recordTime}}</span></h3>
                        <ul>
                            <li>
                                <h4>监测状态</h4>
                                <span v-if="listData.runStatus=='正常'" style="color:#4caf50;">{{listData.runStatus}}</span>
                                <span v-else>{{listData.runStatus}}</span>
                            </li>
                            <li>
                                <h4>通讯状态</h4>
                                <span v-if="listData.connectStatus == '离线'" style="color:#f55353;">{{listData.connectStatus}}</span>
                                <span v-else>{{listData.connectStatus}}</span>
                            </li>
                        </ul>
                        <img v-if="listData.runStatus == '正常'" src="../../assets/img/zhengchang.jpg" alt="" />
                        <img v-else src="../../assets/img/gaojing.jpg" alt="" />
                    </div>
                </div>
                <div class="main_bot" :style="{height: heightBot + 'px'}">
                    <div class="data_trend clearfix">
                        <div class="data_select" style="cursor: pointer;">
                            <em></em>
                            <span :class="{colorBlue:isActive}" @click="dataTrendClick(1)">{{dataTrendName1}}</span>
                            <span :class="{colorBlue:!isActive}" @click="dataTrendClick(2)">{{dataTrendName2}}</span>
                        </div>
                        <div class="condition">
                            <div class="condi_scope" v-if="dataTrendShow">
                                <ul v-show="select1">
                                    <li :class="{'scope_select': index == radio1}" v-for="(item,index) in scopeStatus" :key="index" @click="scopeClick(index)">{{item.name}}</li>
                                </ul>
                                <div class="custom" v-show="!select1">
                                    <el-date-picker
                                        v-model="customData"
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        @click.native.prevent="dateClick()">
                                    </el-date-picker>
                                    <el-button type="primary" @click="sureBtn()">确定</el-button>
                                    <el-button type="primary" @click="cancelClick()">取消</el-button>
                                </div>
                            </div>
                            <div class="screenBtn" v-else>
                                <!-- <a @click="aa">导出</a> -->
                                <a @click="screenBtnShow = true">筛选</a>
                                <div class="screenTip" v-show="screenBtnShow">
                                    <div class="screenHead">
                                        <div class="headTxt">筛选</div>
                                        <div class="headIcon" @click.stop="screenBtnShow = false"></div>
                                    </div>
                                    <div class="screenMain">
                                        <el-form :model="ruleFormOption" ref="ruleFormOption" class="demo-ruleForm">
                                            <el-form-item v-if="listData.type == 8">
                                               <el-input placeholder="搜索设备编号" v-model="detailsListData.channelNo" clearable></el-input>
                                            </el-form-item>
                                            <el-form-item prop="deviceStatusVal" v-else> 
                                                <div class="formHead">{{deviceStatus.title}}</div>
                                                <div class="formMain">
                                                    <el-checkbox-group v-model="ruleFormOption.deviceStatusVal">
                                                        <el-checkbox-button v-for="(item,index) in deviceStatus.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-form-item>
                                            <el-form-item prop="pointStateVal"> 
                                                <div class="formHead">{{pointState.title}}</div>
                                                <div class="formMain">
                                                    <el-checkbox-group v-model="ruleFormOption.pointStateVal">
                                                        <el-checkbox-button v-for="(item,index) in pointState.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-form-item>
                                            <el-form-item prop="batteryStateVal" v-if="listData.type == 2 || listData.type == 3 || listData.type == 5 || listData.type == 6 || listData.type == 7"> 
                                                <div class="formHead">{{batteryState.title}}</div>
                                                <div class="formMain">
                                                    <el-checkbox-group v-model="ruleFormOption.batteryStateVal">
                                                        <el-checkbox-button v-for="(item,index) in batteryState.option" :key="index" :label="item.value">{{item.name}}</el-checkbox-button>
                                                    </el-checkbox-group>
                                                </div>
                                            </el-form-item>
                                            <el-form-item> 
                                                <div class="formHead">时间区间:</div>
                                                <div class="formMain">
                                                    <el-date-picker
                                                        v-model="dataTime"
                                                        value-format="yyyy-MM-dd"
                                                        type="daterange"
                                                        range-separator="至"
                                                        start-placeholder="开始日期"
                                                        :default-value="defaultDate"
                                                        :picker-options="pickerOptions"
                                                        @focus="showSubDate"
                                                        end-placeholder="结束日期">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item class="screenMainBtn">
                                                <el-button @click="resetruleFormOption('ruleFormOption')">重置</el-button>
                                                <el-button type="primary" @click="submitruleFormOption('ruleFormOption')">确定</el-button>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitor_data">
                        <!-- 1电气 -->
                        <div class="monitor_electric" v-show="listData.type == 1">
                            <!-- 监测趋势 -->
                            <div class="electric" v-show="dataTrendShow" v-if="isAuth('common:interface')" :style="{height: heightBot -40 + 'px'}" style="margin:0 auto">
                                <div v-show="select2">
                                    <el-tabs tab-position="left" :style="{width: widthEchart + 'px',height: heightBot-80 + 'px'}" style="margin: 0 auto;">
                                        <el-tab-pane label="剩余电流">
                                            <div id="electric8" :style="{width: widthElectr + 'px',height: heightBot -90 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="温度1">
                                            <div id="electric1" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="温度2">
                                            <div id="electric2" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="温度3">
                                            <div id="electric3" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="温度4">
                                            <div id="electric4" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <!-- <el-tab-pane label="A相电流">
                                            <div id="electric5" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="B相电流">
                                            <div id="electric6" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane>
                                        <el-tab-pane label="C相电流">
                                            <div id="electric7" :style="{width: widthElectr + 'px',height: heightBot -80 + 'px'}" style="margin:0 auto"></div>
                                        </el-tab-pane> -->
                                    </el-tabs>
                                </div>
                                <div class="No" v-show="!select2">
                                    <img src="../../../static/img/Nodata.png">
                                    <span>暂无数据</span>
                                </div>
                            </div>
                            <!-- 监测数据 -->
                            <div class="monitor_table table_data" v-show="!dataTrendShow" v-if="isAuth('common:interface')">
                                <div v-show="select3">
                                    <el-table :data="tableData" style="width: 100%" border id="sortTable">
                                        <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                        <el-table-column label="设备状态" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                                                <div v-else>启用</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="监测状态" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                                <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                                <div v-else>正常</div>
                                            </template>
                                        </el-table-column>
                                        <!-- <el-table-column prop="ia" label="A相电流(A)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.ia > currentAMax" style="color: #f55353">{{scope.row.ia}}</div>
                                                <div v-else>{{scope.row.ia}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="ib" label="B相电流(A)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.ib > currentBMax" style="color: #f55353">{{scope.row.ib}}</div>
                                                <div v-else>{{scope.row.ib}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="ic" label="C相电流(A)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.ic > currentCMax" style="color: #f55353">{{scope.row.ic}}</div>
                                                <div v-else>{{scope.row.ic}}</div>
                                            </template>
                                        </el-table-column> -->
                                        <el-table-column prop="temp1" label="温度1(℃)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp1" style="color: #f55353">{{scope.row.temp1}}</div>
                                                <div v-else>{{scope.row.temp1}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="temp2" label="温度2(℃)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp2" style="color: #f55353">{{scope.row.temp2}}</div>
                                                <div v-else>{{scope.row.temp2}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="temp3" label="温度3(℃)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp3" style="color: #f55353">{{scope.row.temp3}}</div>
                                                <div v-else>{{scope.row.temp3}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="temp4" label="温度4(℃)" min-width="100">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmTemp4" style="color: #f55353">{{scope.row.temp4}}</div>
                                                <div v-else>{{scope.row.temp4}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="rcv" label="剩余电流(mA)" min-width="130">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.isAlarmRcv" style="color: #f55353">{{scope.row.rcv}}</div>
                                                <div v-else>{{scope.row.rcv}}</div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                        <el-table-column prop="recordTime" label="记录时间" min-width="180"></el-table-column>
                                        <el-table-column prop="type" label="处理状态" min-width="100"></el-table-column>
                                    </el-table>
                                    <div style="text-align: right;margin-top: 15px" v-if="statusNum1 > 13">
                                        <el-pagination @size-change="handleSizeChange1"  @current-change="handleCurrentChange1" :current-page.sync="detailsListData.currPage" :page-size="13" layout="prev, pager, next" :total='statusNum1' background></el-pagination>
                                    </div>
                                </div>
                                <div class="No" v-show="!select3">
                                    <img src="../../../static/img/Nodata.png">
                                    <span>暂无数据</span>
                                </div>
                            </div>
                        </div>
                        <!-- 2水压,3液位,4可燃气,5烟感,6灭火瓶 -->
                        <div class="monitor_map" v-show="listData.type !== 1">
                            <!-- 监测趋势 -->
                            <div v-show="dataTrendShow" v-if="isAuth('common:interface')" :style="{height: heightBot -120 + 'px'}" style="margin:0 auto">
                                <div id="trend_map" :style="{width: widthEchart + 'px',height: heightBot -80 + 'px'}" style="margin:20px auto" v-show="select2"></div>
                                <div class="No" v-show="!select2">
                                    <img src="../../../static/img/Nodata.png">
                                    <span>暂无数据</span>
                                </div>
                            </div> 
                            <!-- 监测数据 -->
                            <div class="monitor_table table_data" v-show="!dataTrendShow" v-if="isAuth('common:interface')">
                                <div v-show="select3">
                                  <div v-if="listData.type == 2 || listData.type == 3 || listData.type == 6">
                                    <el-table :data="tableData" style="width: 100%" border>
                                      <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                      <el-table-column label="设备状态" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                                          <div v-else>启用</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="监测状态" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                          <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                          <div v-else>正常</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column :label="listData.labels" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus == 1||scope.row.runStatus == 2" style="color: #f55353">{{scope.row.rcv}}</div>
                                          <div v-else>{{scope.row.rcv}}</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="电池电量" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column prop="recordTime" label="记录时间" min-width="248"></el-table-column>
                                      <el-table-column prop="type" label="处理状态" min-width="146"></el-table-column>
                                    </el-table>
                                  </div>
                                  <div v-else-if="listData.type == 8">
                                    <el-table :data="tableData" style="width: 100%" border>
                                      <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                      <el-table-column prop="channelNo" label="设备编号" width="180" show-overflow-tooltip></el-table-column>
                                      <el-table-column label="监测状态" width="120">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                          <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                          <div v-else>正常</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column prop="resourceName" label="报警设备" width="380" show-overflow-tooltip></el-table-column>
                                      <el-table-column prop="location" label="报警地址" width="400"  show-overflow-tooltip></el-table-column>
                                      <el-table-column prop="alarmTime" label="记录时间" width="200"></el-table-column>
                                      <el-table-column prop="type" label="处理状态" width="129"></el-table-column>
                                    </el-table>
                                  </div>
                                  <div v-else-if="listData.type == 5">
                                    <el-table :data="tableData" style="width: 100%" border>
                                      <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                      <el-table-column label="设备状态" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                                          <div v-else>启用</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="监测状态" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus==1" style="color: #f55353">
                                                 {{scope.row.rcv}}
                                          </div>
                                          <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                          <div v-else>正常</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="电池电量" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="环境温度（℃）" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.exField1">{{scope.row.exField1}}</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                     <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column prop="recordTime" label="记录时间" min-width="258"></el-table-column>
                                      <el-table-column prop="type" label="处理状态" min-width="180"></el-table-column>
                                    </el-table>
                                  </div>
                                <div v-else-if="listData.type == 7">
                                    <el-table :data="tableData" style="width: 100%" border>
                                      <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                      <el-table-column label="设备状态" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                                          <div v-else>启用</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="监测状态" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                          <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                          <div v-else>正常</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="电池电量" min-width="180">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.isAlarmBattery" style="color: #f55353">电量低</div>
                                          <div v-else-if="scope.row.isAlarmBattery==false">正常</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                    <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column prop="recordTime" label="记录时间" min-width="258"></el-table-column>
                                      <el-table-column prop="type" label="处理状态" min-width="180"></el-table-column>
                                    </el-table>
                                  </div>
                                  <div v-else-if="listData.type == 4">
                                    <el-table :data="tableData" style="width: 100%" border>
                                      <el-table-column prop="orderNum" label="序号" width="70"></el-table-column>
                                      <el-table-column label="设备状态" min-width="220">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.deviceStatus" style="color: #f55353">故障</div>
                                          <div v-else>启用</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="监测状态" min-width="220">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                          <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                          <div v-else>正常</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column label="信号强度" min-width="146">
                                        <template slot-scope="scope">
                                          <div v-if="scope.row.signaler == 0 ||scope.row.signaler == 1 || scope.row.signaler == 2">弱</div>
                                          <div v-else-if="scope.row.signaler == 3 || scope.row.signaler == 4 || scope.row.signaler == 5">强</div>
                                          <div v-else>--</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column prop="recordTime" label="记录时间" min-width="318"></el-table-column>
                                      <el-table-column prop="type" label="处理状态" min-width="220"></el-table-column>
                                    </el-table>
                                  </div>
                                    <div style="text-align: right;margin-top: 15px" v-if="statusNum1 > 13">
                                        <el-pagination @size-change="handleSizeChange1"  @current-change="handleCurrentChange1" :current-page.sync="detailsListData.currPage" :page-size="13" layout="prev, pager, next" :total='statusNum1' background></el-pagination>
                                    </div>
                                </div>
                                <div class="No" v-show="!select3">
                                    <img src="../../../static/img/Nodata.png">
                                    <span>暂无数据</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import echarts from 'echarts';
    import {ajaxFuncJson} from '@/api/ajax';
    require('echarts/theme/macarons'); // echarts theme
    export default {
        name: 'monitorDetails',
        components: {
        },
        data () {
            return {
                isActive:true,
                msg: '监控详情',
                currentWidth: '',
                heightCard: '',
                heightBot: '',
                widthEchart: '',
                widthElectr: '',
                addressW: '',
                myChart1: null,myChart2: null,myChart3: null,myChart4: null,myChart5: null,myChart6: null,myChart7: null,myChart8: null,myChart9: null,
                screenBtnShow: false,
                dataTrendShow: true,
                select1: true,select2: true,select3: true,select4: true,select5: true,select6: true,select7: true,select8: true,select9: true,select10: true,select11: true,
                dataTrendName1: '监测趋势',
                dataTrendName2: '监测数据',
                customData: '',
                dataTime: '',
                radio1: '',
                overflowText: '', //文字宽度
                //基本信息数据
                listData: {
                    monitoringName: '',
                    monitoringCode: '',
                    detailAddress: '',
                    deviceStatus: '',
                    type: '',
                    types: '',
                    usernames: '',
                    floorIndex: '',
                    enabled: '',
                    recordTime: '',
                    runStatus: '',
                    connectStatus: '',
                    labels: '',
                    basicUserNames:'',
                },
              pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                  this.choiceDate = minDate.getTime();
                  if (maxDate) {
                    this.choiceDate = ''
                  }
                },
                disabledDate: (time) => {
                  if (this.choiceDate) {
                    const one = 30 * 24 * 3600 * 1000;
                    const minTime = this.choiceDate - one;
                    const maxTime = this.choiceDate + one;
                    return time.getTime() < minTime || time.getTime() > maxTime
                  }
                }
              },
              choiceDate: '',
                //监测数据接口需要的参数
                detailsListData: {
                    channelNo:'',
                    monitoringId: sessionStorage.getItem("saveId"),  //监测id
                    start: '',              //起始时间
                    end: '',                //结束时间
                    deviceStatusS: '',       //设备状态 0 启用  1 故障
                    runStatusS: '',          //监测点运行状态，0 正常 1 告警
                    isAlarmBatteryS: '',     //0:正常 1：告警
                    showTime: 'now',        //当前时间
                    currPage: 1,           //当前页数
                    pageSize: 13            //数量
                },
                //监测趋势接口需要的参数
                analyListData: {
                    // monitoringId: sessionStorage.getItem("saveId"),   //监测id
                    monitoringId: sessionStorage.getItem("saveId"),
                    start: '',              //起始时间
                    end: '',                //结束时间
                    showTime: 'now',
                },
                titleName: '',      //趋势图title
                tableData: [],      //存后台传输的监测数据
                scopeStatus: [
                    {name: '1天'},
                    {name: '7天'},
                    {name: '30天'},
                    {name: '自定义'}
                ],
                //筛选多选值
                ruleFormOption: { 
                    deviceStatusVal:[],
                    batteryStateVal: [],
                    pointStateVal:[]
                },
                //筛选-设备状态
                deviceStatus: {
                    title:'设备状态:',
                    option:[{
                        name:'启用',
                        value:'0'
                    },{
                        name:'故障',
                        value:'1'
                    }]
                },
                defaultDate:new Date(),
                //筛选-监测点状态
                pointState:{
                    title:'监测状态:',
                    option:[{
                        name:'正常',
                        value:'0'
                    },{
                        name:'告警',
                        value:'1'
                    },{
                        name:'预警',
                        value:'2'
                    }]
                },
                //筛选-电池状态
                batteryState:{
                    title:'电池状态:',
                    option:[{
                        name:'正常',
                        value:'0'
                    },{
                        name:'电量低',
                        value:'1'
                    }]
                },
                statusNum1: 0,  //分页总条数
                colors: ['#4caf50','#f55353'],
                tempMax: '', //温度上限值
                currentAMax: '', //A相电流上限值
                currentBMax: '', //B相电流上限值
                currentCMax: '', //C相电流上限值
                windowResize:null,
                tipClientWidth:'',
                tipScrollWidth:'',
            }
        },
        created() {
            if (sessionStorage.getItem("saveId") == sessionStorage.getItem('monitoringId')) {
                this.$store.state.showPopoverContent = false;
                this.$store.state.isMsg = false
            }
           if(this.$route.query.deviceName){
              sessionStorage.setItem('differentiate',true); //判断是否可以取消选中
              this.analyListData.monitoringId= this.$route.query.deviceName;
              this.detailsListData.monitoringId = this.$route.query.deviceName;
              sessionStorage.setItem('saveId',this.$route.query.deviceName)
              sessionStorage.setItem('monitoringId',this.$route.query.deviceName)
              this.$store.state.showPopoverContent = false;
              this.$store.state.isMsg = false;
              this.list();
              this.getAlarmList()
           }

        },
        computed:{
            getMap() {
                return this.$store.state.buildingId
            },
            leftoggle() {
                return this.$store.state.leftoggle
            },
            navTopMsg() {
                return this.$store.state.navTopMsg
            }
        },
        watch: {
            getMap(newV, oldV) { // status的变化，然后执行操作
                this.$router.push({path:'/content/Monitoring'})
            },
            leftoggle(newV, oldV) { // status的变化，然后执行操作
                this.initFont();
            },
            navTopMsg(val) {
                console.log('顶部实时信息已收到！')
              this.analysisList();
              this.dataDetailslist();
              this.list(); //实时告警
            },
            '$route'(to,from) {
                this.refresh()
            }
        },  
        mounted() {
            let that = this;
            if(this.isAuth('common:interface')){
              this.list();
            }
            this.initFont();
            that.windowResize=function(){
              that.initFont();
              that.isScroll();
            };
            window.addEventListener("resize",that.windowResize)
        },
        methods:{
            // aa(){
            // // 获取table的html内容了，里面包括标签的class或id等。
            // const dom = document.getElementById('sortTable').innerHTML

            // // 这样做是为了让excel表格的样式完整
            // const excelHtml = `
            
            //     ${dom}
            // `

            // // 生成Excel
            // const excelBlob = new Blob([excelHtml], {
            //     type: 'application/vnd.ms-excel'
            // })
            // // 通过a标签下载到本地了，下载前可以利用a标签的download属性命名
            // const downloadObj = document.createElement('a')
            // // 兼容firefox
            // const isFirefox = navigator.userAgent.toUpperCase().indexOf('FIREFOX') !== -1
            // if (isFirefox) {
            //     window.open(downloadObj, '_blank')
            //     return null
            // }
            // // 利用URL.createObjectURL()方法为a元素生成blob URL
            // downloadObj.href = URL.createObjectURL(excelBlob)
            // // 给文件命名
            // downloadObj.download = '监测数据.xls'
            // downloadObj.click()
            // },

          //监管端报警小红点
          getAlarmList() { 
            let params = {
                pageType: 0,
                customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
            }
            ajaxFuncJson('/basicData/getAList',params).then(res=>{
              if(res.data.status == 200){
                let InfoArr = JSON.parse(sessionStorage.getItem('leftData'))
                if(this.userType!=0){
                          InfoArr.forEach((item,index)=>{
                            if(res.data.data.length>0){
                              item.alarmTrue = 1;
                              item.children.forEach((item1,index)=>{
                                res.data.data.forEach((item2,index)=>{
                                  if(item1.id == item2){
                                      item1.alarmTrue = 1;
                                  }
                                })
                                
                              })
                            }
                          })
                        }else{
                          InfoArr.forEach((item,index)=>{
                            if(res.data.data.length>0){
                              item.alarmTrue = 1;
                              item.children.forEach((item1,index)=>{

                                item1.children.forEach((item2,index2)=>{  
                                    res.data.data.forEach((item3,index3)=>{
                                      if(item2.id == item3){
                                            item1.alarmTrue = 1;
                                          item2.alarmTrue = 1;
                                      }
                                    })
                                })

                                
                                
                              })
                            }
                          })

                        }




                sessionStorage.setItem("leftData", JSON.stringify(InfoArr));
                this.$store.dispatch("getLeftDataList", InfoArr);
              }
            })
          },


         
          isShowTooltip(el){
            this.tipClientWidth=el.srcElement.clientWidth;
            this.tipScrollWidth=el.srcElement.scrollWidth;
          },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                document.getElementsByClassName('main_bot')[0].style.marginRight='0';
                document.getElementsByClassName('main_top')[0].style.marginRight='0';
              }else {
                document.getElementsByClassName('main_bot')[0].style.marginRight='20px';
                document.getElementsByClassName('main_top')[0].style.marginRight='20px';
              }
            });
          },
            refresh () {
                this.$router.replace({
                    path: '/refresh',
                })
            },
            // 基本信息-后台接口
            list() {
                let parms = {
                    id: sessionStorage.getItem("saveId"), //监测id
                }
                ajaxFuncJson('/monitoringdetails/list',parms).then(res=>{
                    if(res.data.status == 200 && res.data.data != null){
                        sessionStorage.setItem('buildingId',res.data.data.data.buildingId)
                        sessionStorage.setItem('menuS',res.data.data.data.buildingId)
                        this.$store.state.menuS = sessionStorage.getItem("buildingId")
                        // sessionStorage.setItem('Name',res.data.data.data.detailAddress)

                        this.listData.monitoringName = res.data.data.data.monitoringName;
                        this.listData.monitoringCode = res.data.data.data.monitoringCode;
                        this.listData.type = res.data.data.data.type;
                        this.listData.detailAddress = res.data.data.data.detailAddress;
                        if(res.data.data.data.usernames){
                            res.data.data.data.usernames = res.data.data.data.usernames.substring(0,res.data.data.data.usernames.length)
                        }
                        
                        this.listData.basicUserNames=res.data.data.data.usernames;
                        if(res.data.data.data.usernames){
                          this.listData.usernames = res.data.data.data.usernames.replace(/\|/g,'<span style="margin: 0 10px">|</span>');

                        }
                        this.listData.floorIndex = res.data.data.data.floorIndex;
                        this.listData.recordTime = res.data.data.data.recordTime;
                        // 启用状态
                        if(res.data.data.data.enabled == true) {
                            this.listData.enabled = '禁用';
                        } else {
                            this.listData.enabled = '启用';
                        }
                        // 设备状态
                        if(res.data.data.data.deviceStatus == 0) {
                            this.listData.deviceStatus = '启用';
                        } else {
                            this.listData.deviceStatus = '故障';
                        }
                        // 监测类型
                        if(res.data.data.data.type == 1) {
                            this.listData.types = '电气';
                        } else if(res.data.data.data.type == 2) {
                            this.listData.types = '水压';
                        } else if(res.data.data.data.type == 3) {
                            this.listData.types = '液位';
                        } else if(res.data.data.data.type == 4) {
                            this.listData.types = '可燃气';
                        } else if(res.data.data.data.type == 5) {
                            this.listData.types = '烟感';
                        } else if(res.data.data.data.type == 6) {
                            this.listData.types = '灭火器';
                        }else if(res.data.data.data.type == 7) {
                            this.listData.types = '水浸';
                        }else if(res.data.data.data.type == 8) {
                            this.listData.types = '用传';
                        }
                        if(res.data.data.data.type == 4||res.data.data.data.type == 5||res.data.data.data.type == 7||res.data.data.data.type == 8){
                            this.pointState={
                                title:'监测状态:',
                                option:[{
                                    name:'正常',
                                    value:'0'
                                },{
                                    name:'告警',
                                    value:'1'
                                }]
                            }
                        }
                        // 监测状态
                        if(res.data.data.data.runStatus == 1) {
                            this.listData.runStatus = '告警';
                        } else if(res.data.data.data.runStatus == 2){
                            this.listData.runStatus = '预警';
                        }else{
                            this.listData.runStatus = '正常';
                        }
                        // 通讯状态
                        if(res.data.data.data.connectStatus == true) {
                            this.listData.connectStatus = '离线';
                        } else {
                            this.listData.connectStatus = '在线';
                        }
                        //四期判断烟感和可燃气固定7天
                        if(res.data.data.data.type == 4 || res.data.data.data.type == 5){
                          this.radio1 = 1;
                          this.detailsListData.showTime = "seven";
                          this.analyListData.showTime = "seven";
                        }else{
                          this.radio1 = 0;
                          this.detailsListData.showTime = "now";
                          this.analyListData.showTime = "now";
                        }
                        this.dataDetailslist();

                       this.analysisList();
                      this.isScroll();
                    }
                })
            },
            // ...........................监测趋势-后台接口.............
            // 监测趋势图表--单条折线图
            analysis(chartN,idName,unit,xData,ydata,tit,seriData,A,B,lineMin,lineMax,smoothType,lineColor,setattr) {
                let that = this;
                chartN = this.$echarts.init(document.getElementById(idName));
                if(that.listData.type== 8){
                    var stepY = 1;
                }
                let option = {
                    color: ['#4caf50','#198cff','#fb8c00','#f55353'],
                    title: {
                        text: unit,
                        // top: 0,
                        textStyle: {
                            color: '#282828',
                            fontSize: '13',
                            align: 'left',
                            lineHeight:'13',
                            fontWeight: 'normal'
                        },
                    },
                    tooltip: {  //提示框组件
                        trigger: 'axis',
                        confine: true,  //将提示框限制在图表的区域内。
                        axisPointer: {
                            type: 'line',
                            axis: 'x',
                            lineStyle: {
                                color: '#e0e0e0'
                            }
                        },
                        backgroundColor: 'rgba(0,0,0,0.6)',//背景颜色
                        borderRadius: 2,//边框圆角
                        padding: [7, 13, 7, 13], //内边距
                        textStyle: {
                            fontSize: 13,
                            lineHeight: 13,
                        },
                        formatter: function (params) {
                            if(params[0].seriesName == '灭火瓶'){
                              params[0].seriesName = '气压'
                            }
                            return [
                                params[0].name,
                                params[0].seriesName + '：' + params[0].value + unit
                            ].join('<br>');
                        }
                    },
                    legend: {
                        icon: 'rect',
                        itemWidth: 10,
                        itemHeight: 10,
                        selected:'false',
                        textStyle: {
                            color: '#282828',
                            padding:[3,0,0,0],
                        },

                    },
                    grid: {
                        left: 10,
                        right:40,
                        bottom: 0,
                        containLabel: true,
                    },
                    xAxis: {
                        type: 'category',
                        // type: 'time',
                        name: setattr,
                        axisLine: {
                            lineStyle: {
                                color: '#282828'
                            }
                        },
                        axisLabel: {
                            color: '#282828',
                            fontSize: '13px',
                            showMaxLabel:true,
                            formatter: function (value,index) {
                                if (that.analyListData.showTime == 'now' && that.listData.type== 8) {
                                    // return [
                                    //     echarts.format.formatTime('hh:mm:dd',value)
                                    // ]
                                                           return [
                                        echarts.format.formatTime('yyyy-MM-dd',value)
                                    ]
                                } else {
                                    return [
                                        echarts.format.formatTime('yyyy-MM-dd',value)
                                    ]
                                }
                            }
                        },
                        data: xData,
                    },
                    yAxis: {
                        interval:stepY, // 步长
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#efefef'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#282828'
                            }
                        },
                        axisLabel: {
                            color: '#282828',
                            fontSize: '13px',
                        },
                        data: ydata,
                    },
                    series: [
                        {
                            name: tit,
                            align: 'top',
                            type: 'line',
                            smooth: smoothType,
                            showAllSymbol: true,
                            symbol: 'emptyCircle',
                            symbolSize: 9,
                            hoverAnimation:false,
                            itemStyle: {
                                color: {
                                    type: 'line',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: lineColor // 0% 处的颜色
                                    }, {
                                        offset: 1, color: lineColor // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                },
                                emphasis: {
                                    color:lineColor,
                                }
                            },
                            lineStyle: {
                                shadowColor: 'rgba(76, 175, 80, 0.6)',
                                shadowBlur: 6,
                                shadowOffsetY: 4
                            },
                            connectNulls: true,
                            data: seriData,
                            markLine: {     //图表标线
                                silent: true,
                                // symbol: ['none','none'], //标线两端标记的图形
                                label: {
                                    show: true,
                                },
                                lineStyle: {
                                    color: '#FF0000',
                                },
                                data: [
                                                                {
                                        yAxis: A,
                                        lineStyle: {
                                            color: '#FE8463'
                                        }

                                    },
                                                                {
                                        yAxis: B,
                                        lineStyle: {
                                            color: '#FE8463'
                                        }

                                    },
                                    {
                                        yAxis: lineMin,
                                        lineStyle: {
                                            color: '#FF0000'
                                        }

                                    },
                                    {
                                        yAxis: lineMax,
                                                                  lineStyle: {
                                            color: '#FF0000'
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                };
                chartN.setOption(option,true);
            },
            analysisList() {
                let parms = {
                    monitoringId: this.analyListData.monitoringId,
                    start: this.analyListData.start,
                    end: this.analyListData.end,
                    showTime: this.analyListData.showTime
                }
                ajaxFuncJson('/monitoringdetails/bigDatelist',parms).then(res=>{
                    if(res.data.status == 200){
                        let setattr = ''
                         if (this.analyListData.showTime == 'now' && this.listData.type != 8){
                              setattr = 'h';
                         }else{
                              setattr = '日';
                         }
                        let timeArr = [],rcvArr = [],rcvNameArr = [];
                        if(this.listData.type == 1) {
                            let tempArr1 = [],tempArr2 = [],tempArr3 = [],tempArr4 = [],iaArr = [],ibArr = [],icArr = [];
                            this.tempMax = res.data.data.Electric_Temp; //6期修改定位温度最小值
                            this.currentAMax = res.data.data.Electric_CurrentA;//6期修改定位温度最大值

                            this.currentBMax = res.data.data.Electric_CurrentB;//6期修改6期修改定位电流最小值
                            this.currentCMax = res.data.data.Electric_CurrentC;//6期修改6期修改定位电流最大值
                            if(res.data.data.data.length > 0) {
                                this.select2 = true;
                                let datas = res.data.data.data;
                                for(var i in datas) {
                                    timeArr.push(datas[i].recordTime);
                                    rcvArr.push(datas[i].rcv); //剩余电流
                                    tempArr1.push(datas[i].temp1);
                                    tempArr2.push(datas[i].temp2);
                                    tempArr3.push(datas[i].temp3);
                                    tempArr4.push(datas[i].temp4);
                                    iaArr.push(datas[i].ia);
                                    ibArr.push(datas[i].ib);
                                    icArr.push(datas[i].ic);
                                }
                                this.analysis(this.myChart1,'electric1','℃',timeArr,'','温度1',tempArr1,'A','B',this.tempMax,this.currentAMax,true,'#4caf50',setattr);
                                this.analysis(this.myChart2,'electric2','℃',timeArr,'','温度2',tempArr2,'A','B',this.tempMax,this.currentAMax,true,'#198cff',setattr);
                                this.analysis(this.myChart3,'electric3','℃',timeArr,'','温度3',tempArr3,'A','B',this.tempMax,this.currentAMax,true,'#f55353',setattr);
                                this.analysis(this.myChart4,'electric4','℃',timeArr,'','温度4',tempArr4,'A','B',this.tempMax,this.currentAMax,true,'#fb8c00',setattr);
                                // this.analysis(this.myChart5,'electric5','A',timeArr,'','A相电流',iaArr,-10000000000,this.currentAMax,true,'#4caf50',setattr);
                                // this.analysis(this.myChart6,'electric6','A',timeArr,'','B相电流',ibArr,-10000000000,this.currentBMax,true,'#198cff',setattr);
                                // this.analysis(this.myChart7,'electric7','A',timeArr,'','C相电流',icArr,-10000000000,this.currentCMax,true,'#f55353',setattr);
                                this.analysis(this.myChart8,'electric8','mA',timeArr,'','剩余电流',rcvArr,'A','B',this.currentBMax,this.currentCMax,true,'#fb8c00',setattr);
                            } else {
                                this.select2 = false;
                            }
                        } else {
                            if(res.data.data.data.length > 0) {
                                this.select2 = true;
                                let datas = res.data.data.data;
                                let specialData=[];
                                for(var i in datas) {
                                    if(this.listData.type == 8){
                                        timeArr.push(new Date(datas[i].recordTime).Format("yyyy-MM-dd"));
                                    }else{
                                        timeArr.push(datas[i].recordTime);
                                    }
                                    if(this.listData.type == 2) {
                                        rcvArr.push(datas[i].rcv / 1000);
                                    } else if(this.listData.type == 3) {
                                        rcvArr.push(datas[i].rcv / 100);
                                    } else if(this.listData.type==5) {
                                        rcvArr.push({'time':datas[i].recordTime,'value':datas[i].rcv,'exField1':datas[i].exField1});
                                    }else if(this.listData.type==6) {
                                        rcvArr.push(datas[i].rcv);
                                    }else if(this.listData.type==8) {
                                        rcvArr.push(datas[i].total);
                                    }
                                }
                             if(this.listData.type==4||this.listData.type==5||this.listData.type==7){     //可燃气烟感水浸
                                  specialData = res.data.data.echartData;
                             }
                                if(this.listData.type == 2) {
                                    this.analysis(this.myChart9,'trend_map','MPa',timeArr,'','水压',rcvArr,res.data.data.Water_Pressure_A/1000,res.data.data.Water_Pressure_B/1000,res.data.data.Water_Pressure_Min/1000,res.data.data.Water_Pressure_Max/1000,true,'#4caf50',setattr);
                                } else if(this.listData.type == 3) {
                                    this.analysis(this.myChart9,'trend_map','m',timeArr,'','液位',rcvArr,res.data.data.Liquid_A/100,res.data.data.Liquid_B/100,res.data.data.Liquid_Min/100,res.data.data.Liquid_Max/100,true,'#4caf50',setattr);
                                } else if(this.listData.type == 4) {//可燃气
                                    this.getSpecialData('可燃气',false,'#4caf50',-100,-100,specialData,timeArr,setattr,rcvArr)
                                } else if(this.listData.type == 5) { //烟感
                                  this.getSpecialData('烟感',false,'#4caf50',-100,-100,specialData,timeArr,setattr,rcvArr);
                                } else if(this.listData.type == 6) {//灭火器
                                    this.analysis(this.myChart9,'trend_map','MPa',timeArr,'','气压',rcvArr,res.data.data.Fire_bottle_A,res.data.data.Fire_bottle_B,res.data.data.Fire_bottle_Min,res.data.data.Fire_bottle_Max,true,'#4caf50',setattr);
                                }else if(this.listData.type == 7) { //水浸
                                    this.getSpecialData('水浸',false,'#4caf50',-100,-100,specialData,timeArr,setattr,rcvArr);
                                }else if(this.listData.type == 8) {
                                    this.analysis(this.myChart9,'trend_map','次',timeArr,'',this.listData.monitoringName,rcvArr,res.data.data.Liquid_A/100,res.data.data.Liquid_B/100,res.data.data.Liquid_Min/100,res.data.data.Liquid_Max/100,true,'#4caf50',setattr);
                                }
                            } else {
                                this.select2 = false;
                            }
                        }
                    }
                });
            },
          getSpecialData(tit,smoothType,lineColor,lineMin,lineMax,series,timeArr,setattr,rcvArr){
            let arySeries=[];
            series.forEach((key,index)=>{
              let str = key.substring(1, key.length - 1).replace(/ /g,"").replace(/1.0/g,"告警").replace(/0.0/g,'正常');
              let dealAry = [];
              dealAry = str.split(',');
              let json= {
                name: tit,
                align: 'top',
                type: 'line',
                smooth: smoothType,
                showAllSymbol: true,
                symbol: 'emptyCircle',
                symbolSize: 9,
                hoverAnimation:false,
                itemStyle: {
                  color: {
                    type: 'line',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: lineColor // 0% 处的颜色
                    }, {
                      offset: 1, color: lineColor // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                  },
                  emphasis: {
                    color: '#4caf50',
                  }
                },
                lineStyle: {
                  shadowColor: 'rgba(76, 175, 80, 0.6)',
                  shadowBlur: 6,
                  shadowOffsetY: 4
                },
                connectNulls: true,
                data: dealAry,
                markLine: {     //图表标线
                  silent: false,
                  symbol: ['none','none'], //标线两端标记的图形
                  label: {
                    show: false,
                  },
                  lineStyle: {
                    color: '#FF0000'
                  },
                  data: [
                    {
                      yAxis: lineMin
                    },
                    {
                      yAxis: lineMax
                    }
                  ]
                }
              };
              dealAry.forEach((value,index)=>{
                if(dealAry[index]=='告警'&&dealAry[index+1]=='正常'||dealAry[index]=='告警'&&dealAry[index+1]=='告警'){
                  json.itemStyle.color='#f55353';
                  json.itemStyle.emphasis.color='#f55353';                  
                  json.lineStyle.shadowColor='rgba(255, 0, 0, 0.6)';
                }
              });
              arySeries.push(json);
            });
            this.specialAnalysis(this.myChart9,'trend_map','',timeArr,['正常','告警'],tit,arySeries,setattr,rcvArr);
          },
          //烟感 可燃气折线图断续修改
          specialAnalysis(chartN,idName,unit,xData,ydata,tit,arySeries,setattr,rcvArr) {
            let that = this;
            chartN = this.$echarts.init(document.getElementById(idName));
            let option = {
              color: ['#4caf50','#198cff','#fb8c00','#f55353'],
              title: {
                text: unit,
                // top: 0,
                textStyle: {
                  color: '#282828',
                  fontSize: '13',
                  align: 'left',
                  lineHeight:'13',
                  fontWeight: 'normal'
                },
              },
              tooltip: {  //提示框组件
                trigger: 'axis',
                confine: true,  //将提示框限制在图表的区域内。
                axisPointer: {
                  type: 'line',
                  axis: 'x',
                  lineStyle: {
                    color: '#e0e0e0'
                  }
                },
                backgroundColor: 'rgba(0,0,0,0.6)',//背景颜色
                borderRadius: 2,//边框圆角
                padding: [7, 13, 7, 13], //内边距
                textStyle: {
                  fontSize: 13,
                  lineHeight: 13,
                },
                formatter: function (params) {
                //   var htmlStr='';
                //   var valMap={};
                //   console.log(params)
                  console.log(rcvArr)
                //   for(var i=0;i<params.length;i++){
                //     var param=params[i];
                //     var seriesName=param.seriesName;
                //     var name=param.name;
                //     var valueY=param.value;
                    
                //     //过虑无效值
                //     if(params[i].value=="-"){
                //       continue;
                //     }
                //     //过滤重叠值
                //     if(valMap[seriesName]==valueY){
                //       continue
                //     }
                //     valMap[seriesName]=valueY;
                //     htmlStr+=name+'<br/>';
                //     if(valueY=='告警'){
                //         if(rcvArr[i] == 111){
                //             htmlStr+=seriesName+'：'+'烟雾'+valueY+unit+'<br/>';
                //         }else if(rcvArr[i] == 963){
                //             htmlStr+=seriesName+'：'+'防拆'+valueY+unit+'<br/>';
                //         }else{
                //             htmlStr+=seriesName+'：'+valueY+unit+'<br/>';
                //         }
                //     }else{
                //       htmlStr+=seriesName+'：'+valueY+unit+'<br/>';
                //     }
                //   }
                if(tit == '烟感'){
                        let seriesName = params[0].seriesName
                        var htmlStr = params[0].name+'<br/>';
                        var aa  =''
                        rcvArr.forEach((item,index)=>{
                            if(item.time == params[0].name){
                                if(item.value == 1 || item.value == 111){
                                    aa =seriesName+'：'+'烟雾告警'+'<br/>';
                                    if(item.exField1){
                                        aa+='环境温度: '+ item.exField1 +'℃<br/>';
                                    }else{
                                        aa+='环境温度: --<br/>';
                                    }
                                }else if(item.value == 963){
                                    aa =seriesName+'：'+'防拆告警'+'<br/>';
                                    if(item.exField1){
                                        aa+='环境温度: '+ item.exField1 +'℃<br/>';
                                    }else{
                                        aa+='环境温度: --<br/>';
                                    }
                                }else if(item.value == 986){
                                    aa =seriesName+'：'+'高温告警'+'<br/>';
                                   if(item.exField1){
                                        aa+='环境温度: '+ item.exField1 +'℃<br/>';
                                    }else{
                                        aa+='环境温度: --<br/>';
                                    }
                                }else{
                                    aa=seriesName+'：'+'正常'+'<br/>';
                                   if(item.exField1){
                                        aa+='环境温度: '+ item.exField1 +'℃<br/>';
                                    }else{
                                        aa+='环境温度: --<br/>';
                                    }
                                }
                            }

                        })
                        htmlStr+=aa;

                }else{
                var htmlStr='';
                  var valMap={};
                  for(var i=0;i<params.length;i++){
                    var param=params[i];
                    var seriesName=param.seriesName;
                    var name=param.name;
                    var valueY=param.value;
                    //过虑无效值
                    if(params[i].value=="-"){
                      continue;
                    }
                    //过滤重叠值
                    if(valMap[seriesName]==valueY){
                      continue
                    }
                    valMap[seriesName]=valueY;
                    htmlStr+=name+'<br/>';
                    htmlStr+=seriesName+'：'+valueY+unit+'<br/>';
                  }
                }
                  return htmlStr;
                }
              },
              legend: {
                icon: 'rect',
                show:false,
                itemWidth: 10,
                itemHeight: 10,
                selected:'false',
                textStyle: {
                  color: '#282828',
                  padding:[3,0,0,0],
                },

              },
              grid: {
                left: 10,
                right:40,
                bottom: 0,
                containLabel: true,
              },
              xAxis: {
                type: 'category',
                name: setattr,
                axisLine: {
                  lineStyle: {
                    color: '#282828'
                  }
                },
                axisLabel: {
                  color: '#282828',
                  fontSize: '13px',
                  showMaxLabel:true,
                  formatter: function (value,index) {
                    var date = new Date(value);
                    if (that.analyListData.showTime == 'now') {
                        return [
                            echarts.format.formatTime('hh:mm:dd',value)
                        ]
                    } else {
                        return [
                            echarts.format.formatTime('yyyy-MM-dd',value)
                        ]
                    }
                  }
                },
                data: xData,
              },
              yAxis: {
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#efefef'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#282828'
                  }
                },
                axisLabel: {
                  color: '#282828',
                  fontSize: '13px',
                },
                data: ydata,
              },
              // visualMap: {
              //     pieces: [
              //         {
              //             gt: 50,
              //             lte: 200,
              //             color: '#f55353'
              //         }
              //     ],
              // },
              series: arySeries,
            };
            chartN.setOption(option,true);
          },
            // 监测趋势、监测趋势文本点击变化
            dataTrendClick(a) {
                // if(this.dataTrendShow == true) {
                //     this.dataTrendShow = false;
                //     this.dataTrendName1 = '监测数据';
                //     this.dataTrendName2 = '监测趋势';
                // } else {
                //     this.dataTrendShow = true;
                //     this.dataTrendName1 = '监测趋势';
                //     this.dataTrendName2 = '监测数据';
                //     this.resetruleFormOption('ruleFormOption'); //2020.9.28(消除监测趋势警告)
                // }
                if(a==1){
                    this.dataTrendShow = true;
                    this.isActive = true;
                    if(this.$refs['ruleFormOption']){
                         this.resetruleFormOption('ruleFormOption'); //2020.9.28(消除监测趋势警告)
                    }
                }else if(a==2){
                    this.dataTrendShow = false;
                    this.isActive = false;
                }
                this.cancelClick();
                this.customData=''
              this.list();//刷新上面状态
              this.isScroll();
            },
            //监测趋势选择时间
            scopeClick(ind) {
                this.radio1 = ind;
                if(ind == 3) {
                    this.select1 = false;
                    this.analyListData.showTime = 'customize';
                } else {
                    if(ind == 0) {
                        this.analyListData.showTime = 'now';
                    } else if(ind == 1) {
                        this.analyListData.showTime = 'seven';
                    } else if(ind == 2) {
                        this.analyListData.showTime = 'thirty';
                    }

                      this.analysisList();

                }
            },
            // 监测趋势-自定义时间点击placeholder置空
            dateClick() {
                $('.el-date-editor.is-active').find('input')[0].placeholder = '';
                $('.el-date-editor.is-active').find('input')[1].placeholder = '';
            },
            showSubDate(){
              this.defaultDate=new Date();
            },
            // 监测趋势-自定义时间点击确定按钮
            sureBtn() {
                if(this.customData){
                  this.analyListData.showTime = 'customize';
                    this.analyListData.start = this.customData[0];
                    this.analyListData.end = this.customData[1];
                }else{
                    this.analyListData.showTime = '';
                    this.analyListData.start = '';
                    this.analyListData.end = '';
                }
                  this.analysisList();

            },
            // 监测趋势-自定义时间点击取消按钮
            cancelClick() {
                this.select1 = true;
                $('.el-date-editor').find('input')[0].placeholder = '开始日期';
                $('.el-date-editor').find('input')[1].placeholder = '结束日期';
            },

            // ...........................监测数据-后台接口.........................
            dataDetailslist() {
                let parms = {
                    monitoringId: this.detailsListData.monitoringId,
                    start: this.detailsListData.start,
                    end: this.detailsListData.end,
                    deviceStatusS: this.detailsListData.deviceStatusS,
                    connectStatusS: '', //通讯状态，此页面不用
                    runStatusS: this.detailsListData.runStatusS,
                    isAlarmBatteryS: this.detailsListData.isAlarmBatteryS,
                    showTime: this.detailsListData.showTime,
                    currPage: this.detailsListData.currPage,
                    pageSize: this.detailsListData.pageSize,
                    channelNo:this.detailsListData.channelNo
                }
                ajaxFuncJson('/monitoringdetails/dataDetailslist',parms).then(res=>{
                    if(res.data.status == 200){
                        this.statusNum1 = res.data.data.total;
                         this.tableData = [];
                        if(this.statusNum1 > 0) {
                            this.select3 = true;
                            let datas = res.data.data.rows;
                            if(this.listData.type == 2) {
                                this.listData.labels = '水压值(MPa)';
                            } else if(this.listData.type == 3) {
                                this.listData.labels = '液位值(m)';
                            } else if(this.listData.type == 6) {
                                this.listData.labels = '气压值(MPa)';
                            }
                            for(var i in datas) {
                                var obj = {};
                                obj.orderNum = this.detailsListData.pageSize*(this.detailsListData.currPage-1)+parseInt(i) + 1; //序号
                                obj.recordTime = datas[i].recordTime; //记录时间
                                obj.battery = datas[i].battery; //电池电量
                                obj.ia = datas[i].ia; //A相电流
                                obj.ib = datas[i].ib; //B相电流
                                obj.ic = datas[i].ic; //C相电流
                                obj.temp1 = datas[i].temp1; //温度1
                                obj.temp2 = datas[i].temp2; //温度2
                                obj.temp3 = datas[i].temp3; //温度3
                                obj.temp4 = datas[i].temp4; //温度4
                                obj.isAlarmTemp1 = datas[i].isAlarmTemp1; //温度1是否告警
                                obj.isAlarmTemp2 = datas[i].isAlarmTemp2; //温度2是否告警
                                obj.isAlarmTemp3 = datas[i].isAlarmTemp3; //温度3是否告警
                                obj.isAlarmTemp4 = datas[i].isAlarmTemp4; //温度4是否告警
                                obj.isAlarmRcv = datas[i].isAlarmRcv; //电流是否告警
                                obj.runStatus = datas[i].runStatus; // 监测状态
                                obj.deviceStatus = datas[i].deviceStatus; // 设备状态
                                obj.isAlarmBattery = datas[i].isAlarmBattery;
                                obj.signaler = datas[i].signaler;//信号
                                // ----------用传分界线
                                obj.channelNo = datas[i].channelNo;//设备编号
                                obj.resourceName = datas[i].resourceName;//报警设备
                                obj.location = datas[i].location;//报警地址
                                obj.alarmTime = datas[i].alarmTime;//记录时间
                                obj.resourceId = datas[i].resourceId;//记录id
                                obj.rcv = datas[i].rcv; //烟感状态
                                obj.exField1 = datas[i].exField1; //烟感温度值


                                if(this.listData.type == 2) {
                                    obj.rcv = datas[i].rcv / 1000;
                                } else if(this.listData.type == 3) {
                                    obj.rcv = datas[i].rcv / 100;
                                } else if(this.listData.type == 4) {
                                    //水压值，液位值，烟感、可燃气：0正常，1告警。灭火器：气压值',电气：剩余电流
                                    if(datas[i].rcv == 0) {
                                        obj.rcv = '正常';
                                    } else {
                                        obj.rcv = '告警';
                                    }
                                }else if(this.listData.type == 5){
                                    if(datas[i].rcv == 0) {
                                        obj.rcv = '正常';
                                    } else if(datas[i].rcv == 1 || datas[i].rcv == 111){
                                        obj.rcv = '烟雾告警';
                                    }else if(datas[i].rcv == 963){
                                        obj.rcv = '防拆告警';
                                    }else if(datas[i].rcv == 986){
                                        obj.rcv = '高温告警';
                                    }
                                } else {
                                    obj.rcv = datas[i].rcv;
                                }
                                if(datas[i].battery == null) {
                                    obj.battery = '--';
                                } else { //四期数据处理
                                    if(this.listData.type == 2){
                                        obj.battery = datas[i].battery / 100;
                                    }else if(this.listData.type == 3){
                                        obj.battery = datas[i].battery / 100;
                                    }else if(this.listData.type == 6){
                                        obj.battery = datas[i].battery / 10;
                                    }else{
                                        obj.battery = datas[i].battery;
                                    }
                                }
                                // 处理状态
                              if(datas[i].runStatus){
                                if(datas[i].type == 0) {
                                  obj.type = '待处理';
                                } else if(datas[i].type == 1) {
                                  obj.type = '处理中';
                                } else if(datas[i].type == 2) {
                                  obj.type = '审核中';
                                } else if(datas[i].type == 3) {
                                  obj.type = '已结束';
                                } 
                              }else {
                                obj.type = '--';
                              }
                                this.tableData.push(obj)
                            }
                        } else {
                            this.select3 = false;
                        }
                    }
                })
            },
            //分页按钮
            handleCurrentChange1(val){
                this.tableData = [];
                this.detailsListData.currPage = val;
                this.dataDetailslist();
            },
            //分页按钮
            handleSizeChange1(val){
                this.tableData = [];
                this.detailsListData.currPage = val;
                this.dataDetailslist();
            },
            // 筛选确定按钮
            submitruleFormOption(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.tableData = [];
                        this.detailsListData.currPage = 1;
                        this.detailsListData.deviceStatusS = this.ruleFormOption.deviceStatusVal.join(',');
                        this.detailsListData.runStatusS = this.ruleFormOption.pointStateVal.join(',');
                        this.detailsListData.isAlarmBatteryS = this.ruleFormOption.batteryStateVal.join(',');
                        if(this.dataTime == []|| !this.dataTime) {
                            this.detailsListData.showTime = 'now';
                            this.detailsListData.start = '';
                            this.detailsListData.end = '';

                        } else {
                            this.detailsListData.showTime = 'customize';
                            if(this.dataTime){
                                this.detailsListData.start = this.dataTime[0];
                                this.detailsListData.end = this.dataTime[1];
                            }else{
                                this.detailsListData.start = '';
                                this.detailsListData.end = '';
                            }
                        };
                        this.dataDetailslist();
                        this.screenBtnShow = false;
                    } else {
                        return false;
                    }
                });
            },
            // 筛选重置按钮
            resetruleFormOption(formName) {
                this.$refs[formName].resetFields();
                this.dataTime = '';
                this.tableData = [];
                this.detailsListData.currPage = 1;
                this.detailsListData.showTime = 'now';
                this.detailsListData.deviceStatusS = '';
                this.detailsListData.runStatusS = '';
                this.detailsListData.isAlarmBatteryS = '';
                this.detailsListData.start = '';
                this.detailsListData.end = '';
                this.detailsListData.channelNo = '';
                this.dataDetailslist();
            },
            initFont() {
                let that = this;
                let basicWidth = $('.main_top').width();
                this.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                this.heightBot = this.heightCard - $('.main_top').outerHeight(true);
                this.widthEchart = $('.monitor_data').width() * 0.92;
                this.widthElectr = this.widthEchart - 115;
                this.currentWidth = basicWidth - $('.basic_info').outerWidth(true);
                this.addressW = $('.info_con ul:nth-child(1)').width() - 116;
                setTimeout(function(){
                    that.$echarts.init(document.getElementById('electric1')).resize({width: null, height: null});
                    that.$echarts.init(document.getElementById('electric2')).resize({width: null, height: null});
                    that.$echarts.init(document.getElementById('electric3')).resize({width: null, height: null});
                    that.$echarts.init(document.getElementById('electric4')).resize({width: null, height: null});
                    // that.$echarts.init(document.getElementById('electric5')).resize({width: null, height: null});
                    // that.$echarts.init(document.getElementById('electric6')).resize({width: null, height: null});
                    // that.$echarts.init(document.getElementById('electric7')).resize({width: null, height: null});
                    that.$echarts.init(document.getElementById('electric8')).resize({width: null, height: null});
                    that.$echarts.init(document.getElementById('trend_map')).resize({width: null, height: null});
                },200)
            }, 
            //文字显示...
            changeText(e){
                this.overflowText = $(e.toElement).outerWidth(true);
            },
            //返回按钮
            returnBtn(){
                sessionStorage.setItem('returnType',1);//区分是否保留筛选条件历史记录
                this.$router.push({path:'/content/Monitoring'})
            },
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .main_top {
        display: flex;
        margin: 10px 20px 10px 0;
        h3 {
            padding: 20px 0 10px;
            color: $TxteAllcolor;
            line-height: 14px;
            font-weight: bold;
            font-size: $fontSizeThree;
            span {
                float: right;
                padding-right: 20px;
                font-weight: normal;
            }
        }
    }
    .basic_info {
        @include wh(58%,187px);
        margin-right: 10px;
        padding-left: 2%;
        background-color: $backgroundTxt;
        color: $TxteAllcolor;
        font-size: $fontSizeThree;
    }
    .info_con ul {
        float: left;
        &:nth-child(1) {
            width: 52.81%;
            span:nth-child(1) {
                float: left;
                width: 74px;
            }
        }
        li {
            padding: 8px 0;
            line-height: 18px;
            span:nth-child(1) {
                float: left;
                width: 60px;
            }
          .container_people{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: calc(100% - 78px);
          }
        }
        .addressDiv {
            float: left;
            .addressL {
                @include textOverflow;
                i {
                    font-style: normal;
                }
            }
        }
        .green {
            color: #4caf50;
        }
    }
    .current_state {
        flex: 1;
        @include wh(41.4%,187px);
        padding-left: 2%;
        background-color: $backgroundTxt;
        ul {
            float: left;
            margin-right: 20px;
        }
        li {
            @include wh(120px,60px);
            background-color: #f2f2f2;
            text-align: center;
            h4 {
                padding: 10px 0;
                color: $TxteAllcolor;
                line-height: $fontSizeThree;
                font-size: $fontSizeThree;
                font-weight: normal;
            }
            span {
                line-height: $fontSizeFive;
                font-size: $fontSizeFive;
            }
            &:nth-child(1) {
                margin-bottom: 10px;
                span {
                    color: #ff0000;
                }
            }
            &:nth-child(2) {
                span {
                    color: #4caf50;
                }
            }
            
        }
        img {
            float: left;
            @include wh(228px,130px);
        }
    }
    .main_bot {
        position: relative;
        margin-right: 20px;
        background-color: #fff;
    }
    .data_trend {
        width: 100%;
        margin-bottom: 10px;
        border-bottom: 1px solid #f0f0f0;
        background-color: #fafafa;
        line-height: 38px;
        .data_select {
            float: left;
            em {
                display: inline-block;
                width: 6px;
                height: 16px;
                margin: 0 8px 0 10px;
                background-color: #198cff;
                vertical-align: -3px;
            }
            span {
                padding-right: 20px;
                color: $TxteAllcolor;
                line-height: $fontSizeThree;
                font-size: $fontSizeThree;
            }
            .colorBlue {
                color: #198cff;
                font-size: 13px;
                cursor: pointer;
            }
        }
        .condi_scope {
            float: right;
            margin-right: 20px;
            li {
                margin-left: 10px;
                float: left;
                @include wh(60px,24px);
                margin-top: 7px;
                padding: 0 10px;
                color: $TxteAllcolor;
                text-align: center;
                line-height: 24px;
                font-size: 13px;
                cursor: pointer;
                &:hover {
                    background-color: #e5f2ff;
                    color: $TxteAllcolor;
                }
            }
            .scope_select {
                color: #fff !important;
                background-color: #198cff !important;
            }
        }
        .screenBtn{
            position: relative;
            a {
                float: right;
                margin-right: 20px;
            }
            .screenTip {
                position: absolute;
                right:22px;
                top: 30px;
                z-index: 1000;
                width: 340px;
                min-height: 345px;
                border: 1px solid #d1e8ff;
                -webkit-box-shadow: 0 0 4px #198cff;
                -moz-box-shadow: 0 0 4px #198cff;
                box-shadow: 0 0 4px #198cff;
                background-color: #fff;
                .screenHead {
                    .headTxt {
                        margin:20px 0;
                        margin-left: 20px;
                        font-size: $fontSizeFive;
                        line-height: $fontSizeFive;
                        color: $TxteAllcolor;
                        font-weight: bold;
                    }
                    .headIcon{
                        position: absolute;
                        right: 0;
                        top: 0;
                        display: inline-block;
                        width: 42px;
                        height: 42px;
                        cursor: pointer;
                        @include bgImg('../../assets/img/close.png');
                        &:hover{
                            @include bgImg('../../assets/img/closeClick.png');
                        }
                    }
                }
                .screenMain {
                    padding: 0 20px;
                    & .el-form{
                        min-height: 241px;
                        position: relative;
                        .formHead{
                          font-size: $fontSizeTwo;
                          line-height: $fontSizeTwo;
                          margin-bottom: 10px;
                          color: #999999;
                        }
                    }
                }
            }
        }
    }
    .monitor_data {
        &> div {
            background-color: #fff;
        }
        .monitor_electric {
            .electric>div{
 
            }
            .el-tabs--left {
                margin: 20px 0 !important;

            }
        }
        .electric{
            @include flexible;
            @include alignItems(center);
            @include justify(center);
        }
        #trend_map{
            @include flexible;
            @include alignItems(center);
            @include justify(center);
        }
        .monitor_table {
            margin: 0 10px;
        } 
    }
</style>



// WEBPACK FOOTER //
// src/page/Monitoring/monitorDetails.vue